// Curated Wisconsin / Illinois / Midwest locations for the mocked address suggestions.
export const ADDRESS_SUGGESTIONS = [
  "Milwaukee Mitchell Intl Airport (MKE), Milwaukee, WI",
  "Chicago O'Hare Intl Airport (ORD), Chicago, IL",
  "Chicago Midway Airport (MDW), Chicago, IL",
  "Dane County Regional Airport (MSN), Madison, WI",
  "General Mitchell Field, Milwaukee, WI",
  "Fiserv Forum, Milwaukee, WI",
  "American Family Field, Milwaukee, WI",
  "Pfister Hotel, 424 E Wisconsin Ave, Milwaukee, WI",
  "The Iron Horse Hotel, 500 W Florida St, Milwaukee, WI",
  "Hilton Milwaukee City Center, 509 W Wisconsin Ave, Milwaukee, WI",
  "Marriott Downtown Chicago, 540 N Michigan Ave, Chicago, IL",
  "Drake Hotel, 140 E Walton Pl, Chicago, IL",
  "Lake Geneva Resort, 7036 Grand Geneva Way, Lake Geneva, WI",
  "Kohler Whistling Straits, N8501 County Rd LS, Sheboygan, WI",
  "Wrigley Field, 1060 W Addison St, Chicago, IL",
  "Soldier Field, 1410 Special Olympics Dr, Chicago, IL",
  "Navy Pier, 600 E Grand Ave, Chicago, IL",
  "Madison Capitol Square, 2 E Main St, Madison, WI",
  "Green Bay Lambeau Field, 1265 Lombardi Ave, Green Bay, WI",
  "Naperville Downtown, Naperville, IL",
  "Schaumburg, IL",
  "Rockford, IL",
  "Evanston, IL",
  "Oak Brook, IL",
  "Highland Park, IL",
];

export const FLEET_FALLBACK = [
  { vehicle_id: "luxury-sedan", name: "Luxury Sedan" },
  { vehicle_id: "lux-suv", name: "Lux SUV" },
  { vehicle_id: "lux-xl-suv", name: "Lux XL-SUV" },
  { vehicle_id: "luxury-suv-6pax", name: "Luxury SUV" },
  { vehicle_id: "sprinter-van", name: "Sprinter Van" },
];

export const STATUS_META = {
  pending:              { label: "Pending",              color: "#A1A1AA" },
  new:                  { label: "Pending",              color: "#A1A1AA" },
  accepted:             { label: "Accepted",             color: "#3B82F6" },
  assigned:             { label: "Accepted",             color: "#3B82F6" },
  dispatched:           { label: "Dispatched",           color: "#6366F1" },
  accepted_by_driver:   { label: "Driver accepted",      color: "#8B5CF6" },
  en_route:             { label: "En route",             color: "#F59E0B" },
  on_location:          { label: "On location",          color: "#EC4899" },
  customer_in_car:      { label: "Customer in car",      color: "#D4AF37" },
  in_progress:          { label: "Customer in car",      color: "#D4AF37" },
  clear_at_destination: { label: "Clear at destination", color: "#06B6D4" },
  completed:            { label: "Completed",            color: "#10B981" },
  cancelled:            { label: "Cancelled",            color: "#EF4444" },
  paused:               { label: "Paused",               color: "#71717A" },
};

export const BRAND = {
  name: "Delux Limo Trans Group",
  tagline: "Arrive with distinction.",
  phones: ["(414) 333-6275", "(414) 533-5895"],
  email: "reservations@deluxlimotransgroup.com",
  area: "Wisconsin · Illinois · Midwest",
  est: "2023",
  facebook: "https://www.facebook.com/profile.php?id=61551904598867",
  googleMaps: "https://maps.app.goo.gl/YRoTrwqrsi7bH4TSA",
};
